var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"variant":_vm.variant,"size":_vm.size},on:{"click":_vm.clicked}},[_c('font-awesome-icon',{class:_vm.textClass,attrs:{"icon":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }